import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { DateTimeAccuracy, LocalizedDateTime } from "../LocalizedDateTime";

export const formatDateTime = (value: string) => value
    && value !== "0001-01-01T00:00:00Z" ? <LocalizedDateTime time={value} accuracy={DateTimeAccuracy.Minute} isTooltip={true} />
    : '-';

export const formatNull = value => value
    ? value
    : '-';

export const formatUndefined = value => value !== undefined
    ? value
    : '-';

export const formatCheck = value => value
    ? <FontAwesomeIcon icon={faCheck} className="text-success" />
    : <FontAwesomeIcon icon={faXmark} className="text-danger" />;
